<template>
  <div
    id="banner">
    <v-card 
      class="banner-contact-image"
      flat
      tile
      img="/img/static/doctor-david-office-mural.jpeg">
      <div
        class="banner-contact-image">
      </div>
    </v-card>
    <div
      class="banner-content">
      <v-layout
        column
        align-center
        justify-center>
        <p
          class="banner-name">
          Dr David Aguirre
        </p>
        <p
          class="banner-title">
          Contáctanos.
          <br class="banner-title-br">
          Estamos para escucharte.
        </p>
        <!-- start reserve button -->
        <v-btn
          @click="$vuetify.goTo('#form', {offset: -50})"
          class="banner-reserve-button"
          color="white">
          <p
            class="banner-reserve-button-text">
            Haz tu Cita
          </p>
        </v-btn>
        <!-- end reserve button -->
      </v-layout>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    setReserve () {
      this.$store.commit('setReservation', true)
    }
  }
}
</script>
<style 
  scoped>
  @media screen and (max-width: 600px) {
    .banner-title-br {
      display: none
    }
    .banner-title {
      font-size: 35px !important;
    }
  }
  .banner-contact-image {
    position: absolute;
    width: 100vw; 
    height: 100vh;
  }
  .banner-name {
    color: white;
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 10px
  }
  .banner-title {
    align-self: center;
    max-width: 90%;
    color: white;
    font-weight: bold;
    font-size: 50px;
    margin-bottom: 30px
  }
  .banner-reserve-button {
    align-self: center;
    width: 120px;
  }
  .banner-reserve-button-text {
    color: #263cc8;
    text-transform: none !important;
    font-weight: bold;
  }
  .banner-content {
    background-color: rgba(0, 0, 0, 0.587);
    position: relative;
    z-index: 10;
    height: 100vh;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #banner {
    position: fixed;
    top: 0;
    height: 100vh;
    min-height: 100vh;
    max-height: 100vh;
    overflow: hidden;
    width: 100%;
    align-content: center;
    justify-content: center;
    z-index: 1
  }
  video {
    object-fit: cover;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
  }
</style>